import {BonusTier} from '../types/EligibleAcceleratorBonus.types';

export const TOTAL_BONUSES = 3;
export const TOTAL_SLOTS = 15;
export const SLOTS_PER_BONUS = 5;

export const BONUS_TIERS: BonusTier[] = [
  {bonusNumber: 1, amountLabel: '$500 bonus', startSlot: 1},
  {bonusNumber: 2, amountLabel: '$1,000 bonus', startSlot: 6},
  {bonusNumber: 3, amountLabel: '$2,000 bonus', startSlot: 11},
];

export const ELIGIBLE_ACCELERATOR_FALLBACK_TITLE =
  'Eligible for Coach Accelerator Bonus';
export const NEW_CLIENTS_PQV_FALLBACK = 'New Clients with at least 275 PQV:';
export const ELIGIBLE_THROUGH_FALLBACK = 'Eligible through';
